(function (angular) {
  "use strict";

  angular.module('myApp').component("selectBoxTwo", {
    templateUrl: "/core/components/selectBoxTwo/select-box-two.tpl.html",
    transclude: true,
    bindings: {
      name: '@',
      label: '@',
      required: '@',
      data: '=',
      service: '=',
      change: '&',
    },
    controller: ['$scope', function($scope) {
      $scope.number = 0;
    }],
  });

}(window.angular));
